/*
  Kiwi Ears · site footer behaviour (sections/kh-footer.liquid), 2026-10-09.

  1. Link groups become an accordion under 640px: real <button aria-expanded>
     + region, height eased with GSAP. Above 640px every group is open and the
     buttons are hidden, so desktop and tablet keep plain columns.
  2. Newsletter: in-place AJAX submit with inline error and success states.
     If Shopify answers with its /challenge captcha, fall back to a real
     submit so the customer can pass it.
  3. Header hides while the footer fills the lower half of the screen
     (body.kf-foot), and the sticky ATC bar steps aside (body.kf-end).
  4. Motion (GSAP + ScrollTrigger, skipped under reduced motion): groups and
     trust items rise in once, and the brand line rises.
  5. Back to top — through Lenis when it is running, native smooth otherwise.

  GSAP is deferred from the end of layout/theme.liquid, after this file, so
  everything that needs it waits for DOMContentLoaded.
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-kft]');
  if (!root || root.__kft) return;
  root.__kft = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phone = window.matchMedia('(max-width: 639px)');

  /* ---------------------------------------------------------- 1 accordion */
  var groups = [].slice.call(root.querySelectorAll('[data-kft-group]'));
  function setOpen(g, open, animate) {
    var btn = g.querySelector('[data-kft-toggle]');
    var panel = g.querySelector('[data-kft-panel]');
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var gsap = window.gsap;
    if (!animate || !gsap || reduce) {
      panel.hidden = !open;
      panel.style.height = '';
      return;
    }
    gsap.killTweensOf(panel);
    if (open) {
      panel.hidden = false;
      gsap.fromTo(panel, { height: 0 }, { height: 'auto', duration: 0.42, ease: 'power3.out', clearProps: 'height' });
      gsap.from(panel.querySelectorAll('.kft-link'), { y: 6, opacity: 0, duration: 0.3, stagger: 0.025, ease: 'power2.out', clearProps: 'all' });
    } else {
      gsap.to(panel, { height: 0, duration: 0.32, ease: 'power3.inOut', onComplete: function () { panel.hidden = true; panel.style.height = ''; } });
    }
  }
  function syncMode() {
    groups.forEach(function (g) { setOpen(g, !phone.matches, false); });
  }
  groups.forEach(function (g) {
    var btn = g.querySelector('[data-kft-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      setOpen(g, btn.getAttribute('aria-expanded') !== 'true', true);
    });
  });
  syncMode();
  if (phone.addEventListener) phone.addEventListener('change', syncMode);

  /* --------------------------------------------------------- 2 newsletter */
  var form = document.getElementById('kf-news');
  if (form && window.fetch) {
    var input = form.querySelector('input[type="email"]');
    var errEl = document.getElementById('kft-news-err');
    var btn = form.querySelector('button[type="submit"]');
    var label = btn && btn.querySelector('[data-kft-btnlabel]');
    function showErr(msg) {
      if (errEl) errEl.textContent = msg;
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    }
    if (input) input.addEventListener('input', function () {
      if (errEl && errEl.textContent) { errEl.textContent = ''; input.removeAttribute('aria-invalid'); }
    });
    form.addEventListener('submit', function (e) {
      if (!input) return;
      e.preventDefault();
      var v = input.value.trim();
      if (!v) { showErr('Enter your email address.'); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { showErr('That email doesn’t look right. Check for a typo.'); return; }
      if (btn) { btn.disabled = true; if (label) label.textContent = 'Subscribing…'; }
      fetch(form.getAttribute('action'), { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (r.url && r.url.indexOf('/challenge') > -1) { form.submit(); return null; }
          if (!r.ok) throw new Error('status ' + r.status);
          return r.text();
        })
        .then(function (html) {
          if (html === null) return;
          var wrap = document.getElementById('kf-news-wrap');
          var ok = document.createElement('p');
          ok.className = 'kft-news-ok';
          ok.setAttribute('role', 'status');
          ok.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m5 12.5 4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>You’re on the list. Watch your inbox.</span>';
          var gsap = window.gsap;
          function place() { if (wrap) wrap.replaceWith(ok); if (errEl) errEl.textContent = ''; }
          if (gsap && !reduce && wrap) {
            gsap.to(wrap, { opacity: 0, y: -8, duration: 0.25, ease: 'power2.in', onComplete: function () {
              place();
              gsap.from(ok, { opacity: 0, y: 10, scale: 0.97, duration: 0.45, ease: 'back.out(1.6)' });
            } });
          } else { place(); }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; if (label) label.textContent = 'Subscribe'; }
          showErr('Something went wrong on our side. Please try again.');
        });
    });
  }

  /* ------------------------------------------- 3 header / ATC hand-offs */
  var legal = document.getElementById('kf-legal');
  if (legal && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { document.body.classList.toggle('kf-end', e.isIntersecting); });
    }, { threshold: 0 }).observe(legal);
  }
  /* Hide the header only once the reader has scrolled AND the footer fills the
     lower half of the viewport (kept from the previous footer: on short pages
     the footer is on screen at load and must not take the header with it). */
  if ('IntersectionObserver' in window) {
    var footIn = false, ticking = false;
    var paint = function () { ticking = false; document.body.classList.toggle('kf-foot', footIn && window.scrollY > 120); };
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { footIn = e.isIntersecting; });
      paint();
    }, { threshold: 0, rootMargin: '0px 0px -50% 0px' }).observe(root);
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
  }

  /* ------------------------------------------------------- 5 back to top */
  var toTop = root.querySelector('[data-kft-totop]');
  if (toTop) toTop.addEventListener('click', function (e) {
    e.preventDefault();
    if (window.lenis && window.lenis.scrollTo) window.lenis.scrollTo(0, { duration: 1.2 });
    else window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    var skip = document.querySelector('a[href="#MainContent"], main, #MainContent');
    if (skip && skip.focus) { skip.setAttribute('tabindex', '-1'); skip.focus({ preventScroll: true }); }
  });

  /* ------------------------------------------------------------ 4 motion */
  function motion() {
    var gsap = window.gsap, ST = window.ScrollTrigger;
    if (!gsap || !ST || reduce) return;
    gsap.registerPlugin(ST);

    /* content is visible by default; these only play the entrance once */
    ST.batch(root.querySelectorAll('[data-kft-reveal]'), {
      start: 'top 92%', once: true,
      onEnter: function (els) { gsap.from(els, { y: 24, opacity: 0, duration: 0.7, stagger: 0.07, ease: 'power3.out', clearProps: 'transform,opacity' }); }
    });

    var tag = document.getElementById('kf-tagline');
    if (tag) gsap.from(tag, { y: 34, opacity: 0, duration: 0.9, ease: 'power3.out', clearProps: 'transform,opacity',
      scrollTrigger: { trigger: tag, start: 'top 94%', once: true } });

  }
  if (window.gsap || document.readyState === 'complete') motion();
  else document.addEventListener('DOMContentLoaded', motion, { once: true });
})();
